import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = ["cancelButton"]

  uploadPhotos(event) {
    if (event.target.files.length > 0) {
      event.target.form.requestSubmit();
    } else {
      console.log("No file selected.");
    }
  }

  async cancelMeal(event) {
    const mealEntryId = event.target.dataset.mealEntryId

    if (!mealEntryId) {
      // Get data attributes directly from the button element
      const mealCategory = event.target.dataset.mealCategory
      const consumedAt = event.target.dataset.consumedAt

      if (!mealCategory || !consumedAt) {
        console.error("Missing meal category or consumed at data attributes")
        closeModal()
        return
      }

      // Send request to cancel a new entry with diary data
      const path = '/app/profile/meal_entries/cancel_new'
      const request = new FetchRequest("post", path, {
        body: JSON.stringify({
          meal_category: mealCategory,
          consumed_at: consumedAt
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        }
      })

      const response = await request.perform()
      if (response.ok) {
        this.closeModal()
      }
      return
    }

    // Existing entry cancellation
    const path = `/app/profile/meal_entries/${mealEntryId}/cancel`
    const request = new FetchRequest("get", path)

    const response = await request.perform()
    if (response.ok) {
      this.closeModal()
    }
  }

  closeModal() {
    window.Turbo.visit('/recede_historical_location')
  }

  async undoCancelMeal(event) {
    const mealEntryId = event.target.dataset.mealEntryId
    const path = `/app/profile/meal_entries/${mealEntryId}/undo_cancel`
    const request = new FetchRequest("get", path)

    const response = await request.perform()
    if (response.ok) {
      this.closeModal()
    }
  }
}
